import logo from "./logo-2.png"
import { ProfileMain, Navbar } from "components"
import { Link } from "react-router-dom"
import { Box } from "theme-ui"
import { useColorMode } from "theme-ui"
export const Header = () => {
 // theme switcher state for website
 const [colorMode, setColorMode] = useColorMode<string>()

 // function for the dark and light mode switcher
 const modeChanger = () => {
  setColorMode(colorMode === "default" ? "dark" : "default")
 }
 return (
  <div className="py-12">
   <Box
    className="fixed left-0 right-0 top-0 z-30"
    color="text"
    sx={{ stroke: "stroke" }}
    bg="highlight"
   >
    <div className="flex border-b headerBg items-center justify-between">
     {/* ====================== navbar-list-start =========================== */}

     <ul className="flex items-center py-5 px-2 lg:gap-10">
        <Link to="/">
      <li>
       <img src={logo} alt="stuhenburg" className="w-24 lg:w-[180px]" />
      </li>
      </Link>
      {/* =========== Navbar ================= */}
      <div className="hidden lg:flex">
       <Navbar />
      </div>
     </ul>
     {/* ========================= calling-profileMain-component ======================= */}
     <ProfileMain colorMode={colorMode} modeChanger={modeChanger} />
    </div>
   </Box>
  </div>
 )
}
